import React from 'react';
import { Icon } from '@modulor/react';
import BonusesPictogram from '../../BonusesPictogram/BonusesPictogram';
import { Local } from '../../Local/Local';
import { ButtonWithAnalytics } from '../../Button/Button';
import SeoLink from '../../SeoLink/SeoLink';
import NavigationLink from '../NavigationBlock/NavigationLink/NavigationLink';
import { useIsDesktopLayout } from '../../../hooks/useIsDesktopLayout';
import {
  usePromoBonusesPageRedirectCallback,
  usePromoBonusUrl,
} from '../../../hooks/usePromoBonusSystemRedirects';
import { PROMO } from '../../../constants/productTypes';
import { useIsUnifiedPromoBonusSystemEnabled } from '../../../hooks/useIsUnifiedPromoBonusSystemEnabled';
import { getCurrentBonusesRoute } from '../../../utils/routes';
import { BONUSES_HISTORY } from '../../../constants/routeTemplates';
import { EVENT_ACTION } from '../../../constants/ga';
import {
  ANALYTICS_SCHEMA_URLS,
  ANALYTICS_SCREEN_AREA_DETAILS,
  ANALYTICS_SCREEN_AREAS,
} from '../../../constants/analytics';
import { NAMESPACES } from '../../../constants/namespaces';
import styles from '../NavigationBlock/NavigationLink/NavigationLink.module.css';

type BonusNavigationItemProps = {
  screenName: string;
  getPositionIndex: () => number;
};
const BonusNavigationItem = ({
  screenName,
  getPositionIndex,
}: BonusNavigationItemProps) => {
  const isPromoBonusSystemEnabled = useIsUnifiedPromoBonusSystemEnabled();
  const isDesktop = useIsDesktopLayout();

  const redirectToBonusList = usePromoBonusesPageRedirectCallback();
  const promoBonusesUrl = usePromoBonusUrl();

  return (
    <>
      {isPromoBonusSystemEnabled ? (
        <SeoLink productType={PROMO} url={promoBonusesUrl}>
          {/*// @ts-ignore*/}
          <ButtonWithAnalytics
            className={styles.bonuses}
            onClick={redirectToBonusList}
            dataLayerEventData={{
              eventAction: EVENT_ACTION.NAV_BONUSES,
              section_index: 0,
            }}
            analyticsData={{
              schema: ANALYTICS_SCHEMA_URLS.NAVIGATION_CLICK,
              screen_name: screenName,
              screen_area: ANALYTICS_SCREEN_AREAS.SIDEBAR,
              section_index: 0,
              position_index: getPositionIndex(),
              screen_area_detail:
                ANALYTICS_SCREEN_AREA_DETAILS.BONUS_PAGE_CLICK,
            }}
          >
            <Icon name="gift_outlined" className={styles.icon} />
            <span className={styles.bonusTitle}>
              <Local namespace={NAMESPACES.PAGES}>Bonuses</Local>
              <BonusesPictogram />
            </span>
            {!isDesktop ? (
              <Icon name="chevron_right" className={styles.chevron} />
            ) : null}
          </ButtonWithAnalytics>
        </SeoLink>
      ) : (
        // @ts-ignore
        <NavigationLink
          key={getCurrentBonusesRoute()}
          link={getCurrentBonusesRoute()}
          icon={<Icon name="gift_outlined" />}
          title={
            <>
              <Local namespace={NAMESPACES.PAGES}>Bonuses</Local>
              <BonusesPictogram />
            </>
          }
          analyticsData={{
            schema: ANALYTICS_SCHEMA_URLS.NAVIGATION_CLICK,
            screen_name: screenName,
            screen_area: ANALYTICS_SCREEN_AREAS.SIDEBAR,
            section_index: 0,
            position_index: getPositionIndex(),
            screen_area_detail: ANALYTICS_SCREEN_AREA_DETAILS.BONUS_PAGE_CLICK,
          }}
          activeOnRoutes={[BONUSES_HISTORY]}
          dataLayerEventData={{
            eventAction: EVENT_ACTION.NAV_BONUSES,
            section_index: 0,
          }}
        >
          <Local namespace={NAMESPACES.PAGES}>Bonuses</Local>
          <BonusesPictogram />
        </NavigationLink>
      )}
    </>
  );
};

export default BonusNavigationItem;
